import { WorkloadOptimizationAgentStatus } from '@cast/types';

import { useWorkloadOptimizationAgentStatus } from './useWorkloadOptimizationAgentStatus';

export const useWoopAgent = () => {
  const {
    status,
    inPlaceResizeEnabled,
    isLoading: isAgentStatusLoading,
    error,
    refetch,
  } = useWorkloadOptimizationAgentStatus();

  const isWoopAgentInstalled =
    status === WorkloadOptimizationAgentStatus.RUNNING;

  return {
    isWoopAgentReady: isAgentStatusLoading || isWoopAgentInstalled,
    isInPlaceResizing: inPlaceResizeEnabled,
    isAgentStatusLoading,
    isWoopAgentInstalled,
    error,
    refetch,
  };
};
